import { XCircle, TrendingUp, AlertTriangle, DollarSign } from 'lucide-react';

const MarginModal = ({ isOpen, onClose, data, threshold = 0.15 }) => {
    if (!isOpen || !data) return null;

    const costoProveedor = Number(data.costo_proveedor || 0);
    const costosAsociados = costoProveedor * 0.35;
    const costoTotal = costoProveedor + costosAsociados;

    const calculateMargin = (price) => {
        const p = Number(price || 0);
        if (p === 0) return 0;
        return (p - costoTotal) / p;
    };

    const getTrafficLightColor = (margin) => {
        if (margin < 0) return 'bg-red-500/20 text-red-400 border-red-500/30';
        if (margin <= threshold) return 'bg-yellow-400/20 text-amber-400 border-amber-500/30';
        return 'text-emerald-400 border-emerald-500/20';
    };

    const levels = [
        { label: 'Distribuidor', price: data.precio_distribuidor },
        { label: 'Revendedor', price: data.precio_revendedor },
        { label: 'Cliente Final', price: data.precio_cliente_final }
    ];

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-md z-[60] flex items-center justify-center p-4">
            <div className="bg-slate-800 rounded-2xl w-full max-w-sm border border-slate-700 shadow-2xl animate-in zoom-in-95 duration-200">
                <div className="p-5 border-b border-slate-700/50 flex justify-between items-center">
                    <div>
                        <h3 className="text-lg font-bold text-white flex items-center gap-2">
                            <TrendingUp size={20} className="text-cyan-400" /> Rentabilidad del Servicio
                        </h3>
                        <p className="text-xs text-slate-400 mt-1">{data.servicio} - {data.correo_cuenta}</p>
                    </div>
                    <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors">
                        <XCircle size={24} />
                    </button>
                </div>

                <div className="p-5 space-y-6">
                    {/* Estructura de Costos */}
                    <div className="space-y-3">
                        <h4 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">Estructura de Costos</h4>
                        <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-700/50 space-y-2">
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-slate-400">Costo Proveedor</span>
                                <span className="text-white font-mono font-bold">${costoProveedor.toFixed(2)}</span>
                            </div>
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-slate-400">Costos Asociados (35%)</span>
                                <span className="text-slate-300 font-mono italic">${costosAsociados.toFixed(2)}</span>
                            </div>
                            <div className="pt-2 mt-2 border-t border-slate-700/50 flex justify-between items-center">
                                <span className="text-xs font-bold text-cyan-400 uppercase">Costo Total Unitario</span>
                                <span className="text-lg font-bold text-cyan-400 font-mono">${costoTotal.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>

                    {/* Márgenes por Nivel */}
                    <div className="space-y-3">
                        <h4 className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">Márgenes y Precios</h4>
                        <div className="space-y-3">
                            {levels.map((level, idx) => {
                                const margin = calculateMargin(level.price);
                                const colorClass = getTrafficLightColor(margin);
                                return (
                                    <div key={idx} className="flex flex-col gap-1.5">
                                        <div className="flex justify-between items-end px-1">
                                            <span className="text-xs font-medium text-slate-300">{level.label}</span>
                                            <span className="text-xs font-mono text-slate-400">${Number(level.price || 0).toFixed(2)}</span>
                                        </div>
                                        <div className={`flex justify-between items-center p-3 rounded-xl border ${colorClass}`}>
                                            <span className="text-xs font-bold">Margen Bruto</span>
                                            <div className="flex items-center gap-2">
                                                {margin < 0 && <AlertTriangle size={14} className="animate-pulse" />}
                                                <span className="text-sm font-bold font-mono">{(margin * 100).toFixed(1)}%</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="pt-2 text-center">
                        <p className="text-[10px] text-slate-500 italic flex items-center justify-center gap-1">
                            <DollarSign size={10} /> Cálculos basados en costo total unitario proyectado.
                        </p>
                    </div>
                </div>

                <div className="p-4 bg-slate-900/40 rounded-b-2xl border-t border-slate-700/50">
                    <button onClick={onClose} className="w-full bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-xl text-sm font-bold transition-colors">
                        Cerrar Detalle
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MarginModal;
